import { WhmStack, WhmTypography } from "@securitize/reactjs-whm";
import { ReactComponent as Empty } from "../../../../assets/Empty.svg";
import { translationKeys } from "../../../../contexts/I18nContext";
import { useTranslation } from "../../../../hooks/useTranslation";

export const DocumentDataGridEmpty: React.FC = () => {
  const { getTranslation: t } = useTranslation();

  return (
    <WhmStack sx={{ padding: "24px", gap: "16px", alignItems: "center" }}>
      <Empty style={{ height: "124px" }} />
      <WhmStack sx={{ gap: "8px", alignItems: "center" }}>
        <WhmTypography variant="h4" sx={{ height: 32, textAlign: "center" }}>
          {t(translationKeys.DOCUMENT_DATAGRID_EMPTY_TITLE)}
        </WhmTypography>
        <WhmTypography
          variant="body1"
          sx={{
            textAlign: "center",
            height: 24,
          }}
        >
          {t(translationKeys.DOCUMENT_DATAGRID_EMPTY_DESCRIPTION)}
        </WhmTypography>
      </WhmStack>
    </WhmStack>
  );
};
